export default {
  tileTitle: {
    en: "Passport",
    ja: "パスポート"
  },

  passport: {
    en: "Passport",
    ja: "パスポート"
  },
  idCard: {
    en: "ID card",
    ja: "IDカード"
  },
  driverLicense: {
    en: "Driver’s License",
    ja: "運転免許証"
  },

  uploadMainPage: {
    en: "Upload main page",
    ja: "メインページをアップロード"
  },
  uploadRegistrationPage: {
    en: "Upload registration page",
    ja: "登録ページをアップロード"
  },
  registrationPermit: {
    en: "Registration permit"
  }
}
